// extracted by mini-css-extract-plugin
module.exports =  {"label":"_0d624b9a27--label--pjAQt","red":"_0d624b9a27--red--dPV8H","green":"_0d624b9a27--green--TkppN"};